import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { DevicePermission, } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { formulateSdkResponse, onSdkError, verifyDevicePermissions } from './messageHandlingUtils';
/**
 * Responsible for handling barcode based calls.
 */
var BarCodeMessageHandler = /** @class */ (function (_super) {
    __extends(BarCodeMessageHandler, _super);
    function BarCodeMessageHandler(appSdkHost, permissionsService, barCodeService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.permissionsService = permissionsService;
        _this.barCodeService = barCodeService;
        return _this;
    }
    BarCodeMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.barCode.scanBarCode, function (_, barCodeConfiguration) { return _this.checkPermissionsAndCallScanBarCode(barCodeConfiguration); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.barCode.scanBarCode, error, scenario); },
        });
    };
    BarCodeMessageHandler.prototype.checkPermissionsAndCallScanBarCode = function (barCodeConfiguration) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, verifyDevicePermissions(this.permissionsService, DevicePermission.Media)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, formulateSdkResponse(barCodeConfiguration, this.barCodeService.scanBarCode)];
                }
            });
        });
    };
    BarCodeMessageHandler.prototype.validateDependencies = function () {
        if (!this.barCodeService) {
            throw 'No barCodeService provided';
        }
        if (!this.permissionsService) {
            throw 'BarCode is provided but no permissionsService is provided';
        }
    };
    return BarCodeMessageHandler;
}(BaseMessageHandler));
export { BarCodeMessageHandler };
//# sourceMappingURL=barCode-message-handler.js.map